// Общие типы-обёртки ответов API.
//
// ДОПУЩЕНИЕ: точная форма пагинации/ошибок backend на момент написания фронтенда
// не зафиксирована (backend реализуется параллельно). Ниже — распространённая для
// NestJS форма ответа, которую легко адаптировать в src/api/client.ts, если финальный
// backend вернёт другую обёртку (например, { data, meta } вместо { items, total }).

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export interface PageQuery {
  page?: number;
  limit?: number;
}

export interface ApiErrorShape {
  statusCode: number;
  message: string | string[];
  error?: string;
}

export function extractErrorMessage(error: unknown, fallback = "Произошла ошибка. Попробуйте ещё раз."): string {
  const err = error as { response?: { data?: ApiErrorShape; status?: number }; message?: string } | undefined;
  const data = err?.response?.data;
  if (data?.message) {
    return Array.isArray(data.message) ? data.message.join(", ") : data.message;
  }
  if (err?.response?.status === 409) {
    return "Конфликт данных: запись уже занята или пересекается с существующей.";
  }
  if (err?.message) return err.message;
  return fallback;
}
